import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup } from './FormElements';

const FormContainer = styled.div`
  width: 100%;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.text};
`;

const QuestionCard = styled.div`
  background: ${props => props.theme.colors.lightBackground};
  border: 2px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`;

const QuestionText = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${props => props.theme.colors.text};
  margin-bottom: 1rem;
`;

const AnswerButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

const AnswerButton = styled.button`
  flex: 1;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: 2px solid ${props => props.selected ? props.theme.colors.primary : props.theme.colors.border};
  background: ${props => props.selected ? 'rgba(255, 127, 0, 0.15)' : props.theme.colors.lightBackground};
  color: ${props => props.selected ? props.theme.colors.primary : props.theme.colors.text};
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.primary};
    background: rgba(255, 127, 0, 0.1);
  }
`;

const StartupQuestionsScreen = ({ formData, updateFormData, nextStep, prevStep }) => {
  const [answers, setAnswers] = useState({
    isStartup: formData.is_startup_question1 || null,
    hasUpTo5Years: formData.is_startup_question2 || null,
    hasRevenueUpTo1MM: formData.is_startup_question3 || null
  });

  const handleAnswer = (question, value) => {
    setAnswers(prev => ({ ...prev, [question]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Salvar as respostas no formData
    updateFormData({
      is_startup_question1: answers.isStartup,
      is_startup_question2: answers.hasUpTo5Years,
      is_startup_question3: answers.hasRevenueUpTo1MM
    });

    // Se todas as respostas forem "sim", vai para planos startup
    // Se alguma for "não", vai para plano empresas estabelecidas
    const allYes = answers.isStartup === true && 
                   answers.hasUpTo5Years === true && 
                   answers.hasRevenueUpTo1MM === true;
    
    updateFormData({ qualifies_as_startup: allYes });
    nextStep();
  };

  const allQuestionsAnswered = 
    answers.isStartup !== null && 
    answers.hasUpTo5Years !== null && 
    answers.hasRevenueUpTo1MM !== null;

  return (
    <FormContainer>
      <form onSubmit={handleSubmit}>
        <Title>Verificação de Elegibilidade para Plano Startup</Title>

        <QuestionCard>
          <QuestionText>Sua empresa é startup?</QuestionText>
          <AnswerButtons>
            <AnswerButton
              type="button"
              selected={answers.isStartup === true}
              onClick={() => handleAnswer('isStartup', true)}
            >
              Sim
            </AnswerButton>
            <AnswerButton
              type="button"
              selected={answers.isStartup === false}
              onClick={() => handleAnswer('isStartup', false)}
            >
              Não
            </AnswerButton>
          </AnswerButtons>
        </QuestionCard>

        <QuestionCard>
          <QuestionText>Tem até 05 anos de data de fundação?</QuestionText>
          <AnswerButtons>
            <AnswerButton
              type="button"
              selected={answers.hasUpTo5Years === true}
              onClick={() => handleAnswer('hasUpTo5Years', true)}
            >
              Sim
            </AnswerButton>
            <AnswerButton
              type="button"
              selected={answers.hasUpTo5Years === false}
              onClick={() => handleAnswer('hasUpTo5Years', false)}
            >
              Não
            </AnswerButton>
          </AnswerButtons>
        </QuestionCard>

        <QuestionCard>
          <QuestionText>Tem faturamento bruto de até R$1MM/ano?</QuestionText>
          <AnswerButtons>
            <AnswerButton
              type="button"
              selected={answers.hasRevenueUpTo1MM === true}
              onClick={() => handleAnswer('hasRevenueUpTo1MM', true)}
            >
              Sim
            </AnswerButton>
            <AnswerButton
              type="button"
              selected={answers.hasRevenueUpTo1MM === false}
              onClick={() => handleAnswer('hasRevenueUpTo1MM', false)}
            >
              Não
            </AnswerButton>
          </AnswerButtons>
        </QuestionCard>

        <ButtonGroup>
          <Button type="button" onClick={prevStep}>Voltar</Button>
          <Button type="submit" primary disabled={!allQuestionsAnswered}>
            Continuar
          </Button>
        </ButtonGroup>
      </form>
    </FormContainer>
  );
};

export default StartupQuestionsScreen;
